import * as React from "react";

import { makeStyles, TextField } from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: "5px",
    color: "#acacac",
    border: "2px solid #ededed",
    margin: "auto",
    alignSelf: "center",

    height: "40px",

    "& .MuiInputBase-root": {
      dir: "ltr",
      height: "58px",
      width: "95%",
      margin: "auto",
    },
    "& .MuiOutlinedInput-input": {
      // padding: '0 !important',
    },
  },
  chip: {
    "& .MuiChip-root": {
      height: "75%",
      transform: "translate(9px, 0)",
      marginLeft: "8px",
      padding: "3px 26px",
      backgroundColor: "rgb(136 152 170 / 0.21)",
      borderRadius: "26px",
      color: "#8898aa !important",
      fontSize: "1.181rem",
      fontFamily: "Vazir-Bold",
      boxShadow: "0 1px 3px 0 rgba(50, 50, 93, 0.18)",
    },
  },
  error: {
    borderColor: "red",
  },
}));

const SimpleTextField = ({
  customClassName,
  customAdornmentClassName,
  EndAdornment,
  error,
  ...props
}) => {
  const classes = useStyles();

  return (
    <TextField
      variant="outlined"
      fullWidth
      className={clsx(
        classes.root,
        customClassName && customClassName,
        error && classes.error
      )}
      InputProps={{
        endAdornment: (
          <div
            className={clsx(
              classes.chip,
              customAdornmentClassName && customAdornmentClassName
            )}
          >
            {EndAdornment}
          </div>
        ),
      }}
      {...props}
    />
  );
};

export default SimpleTextField;
